// WALLET-P1: does this reader see dollars only? `companies.get` (the cached company read every
// member can call) carries `wallet_view`: true for a client of a company whose wallet is on or
// ever was. Token counts then live only in the wallet entry detail. While the flag is unknown
// (loading or error) token summaries stay hidden rather than flash.
import { useQuery } from "@tanstack/react-query";
import type { Api } from "../../api/client";
import { companyQuery } from "../queries";

export function useWalletOn(api: Api, co: string, enabled = true): boolean {
  const company = useQuery({ ...companyQuery(api, co), enabled });
  return enabled ? (company.data?.wallet_view ?? true) : false;
}
